import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';
import {Navigate} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const Statistics = lazy(() => import('@/pages/mngt/statistics/Statistics'));
const MenuStatistics = lazy(() => import('@/pages/mngt/statistics/MenuStatistics'));
const ContentsStatistics = lazy(() => import('@/pages/mngt/statistics/ContentsStatistics'));
const MonthStatistics = lazy(() => import('@/pages/mngt/statistics/MonthStatistics'));
const DayStatistics = lazy(() => import('@/pages/mngt/statistics/DayStatistics'));

const statisticsRoutes: RouteObject[] = [
  {
    path: '/mngt/statistics',
    element: withSuspense(<Statistics />),
    children: [
      {
        index: true,
        element: <Navigate to="menu" replace />
      },
      {
        path: 'menu',
        element: withSuspense(<MenuStatistics />)
      },
      {
        path: 'contents',
        element: withSuspense(<ContentsStatistics />)
      },
      {
        path: 'month',
        element: withSuspense(<MonthStatistics />)
      },
      {
        path: 'day',
        element: withSuspense(<DayStatistics />)
      }
    ]
  }
];

export default statisticsRoutes;
